<template>
  <goods-form />
</template>

<script>
import GoodsForm from './components/GoodsForm'

export default {
  name: 'GoodsEdit',
  components: { GoodsForm }
}
</script>
